// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2AX7M","modalFooterButton":"ModalNotes_modalFooterButton__fCCKL"};